import React from "react";
import { Card, CardContent, Stack, Skeleton } from "@mui/material";

const GroupCardSkeleton: React.FC = () => {
  return (
    <Card elevation={0} sx={{ borderRadius: 1 }}>
      <CardContent>
        <Stack spacing={2}>
          <Stack spacing={0.5}>
            {/* Title */}
            <Skeleton variant="text" width="60%" height={32} />
            {/* Description */}
            <Skeleton variant="text" width="80%" height={20} />
          </Stack>

          {/* Chips row */}
          <Stack direction="row" spacing={1} alignItems="center">
            <Skeleton variant="rounded" width={60} height={24} />
            <Skeleton variant="rounded" width={50} height={24} />
            <Skeleton variant="rounded" width={80} height={24} />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default GroupCardSkeleton;
